export * from './types';
export * from './SQLJSProvider';
export * from './SQLJSWorkerProvider';
export * from './StorageManager';

// Re-export the main functions that components use
import { StorageManager } from './StorageManager';

export async function seedData(count: number, days?: number): Promise<void> {
    const provider = await StorageManager.getProvider();
    return provider.seedData(count, days);
}

export async function getItems(page: number, pageSize: number, options?: import('./types').QueryOptions) {
    const provider = await StorageManager.getProvider();
    return provider.getItems(page, pageSize, options);
}

export async function getTotalItemCount(options?: import('./types').QueryOptions): Promise<number> {
    const provider = await StorageManager.getProvider();
    return provider.getTotalItemCount(options);
}

export async function getCategories(): Promise<string[]> {
    const provider = await StorageManager.getProvider();
    return provider.getCategories();
}

export async function clearData(): Promise<void> {
    const provider = await StorageManager.getProvider();
    return provider.clearData();
}

export async function getStorageInfo() {
    const provider = await StorageManager.getProvider();
    return provider.getStorageInfo();
}

export async function getStorageProviderName(): Promise<string> {
    const provider = await StorageManager.getProvider();
    return provider.getName();
}

export async function deleteItem(id: string): Promise<void> {
    const provider = await StorageManager.getProvider();
    return provider.deleteItem(id);
}

// Export functionality
export { exportData } from './exportUtils';
export type { ExportFormat } from './exportUtils';

// Import functionality  
export { importData } from './importUtils';
export type { ImportFormat, ImportResult, ImportOptions } from './importUtils';